import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-property.light.webp";
import imageDark from "../images/national-property.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-property",
  displayName: `National Property`,
  datasetProductCode: `GEOSCAPE PROPERTY`,
  subtitle: `National Digital Representation of Property Parcels.`,
  shortDescription: `Property is a seamless national representation of Australia's property parcels. A property is an area of land recognised by the Local Government (or equivalent agency in the ACT) as a singularly valued/rateable entity. The digital property boundaries and their legal identifiers have been derived from the relevant bodies from each Australian State and Territory. It may comprise one or more cadastral parcels or part of a parcel with boundaries not needing to align between the two (although commonly this is the case). Where the property is comprised of multiple parcels, the parcels do not have to be contiguous.
Property is designed to meet the needs of organisations that require a geospatial representation of Australia's property boundaries at both a local and broad scale. The attribution of records provided within Property, and its relationship to other Geoscape Australia datasets such as National Cadastre, allows for the application of the data across a wide range of commercial, government and research uses.`,
  metadata: {
    dateAdded: 1616371200000,
    dataType: ["Polygons"],
    totalFeatureCount: 12662390,
    updateFrequency: `Monthly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/projects/property_release/en/stable/index.html#document-index`,
  productDescriptionLink: `https://docs.geoscape.com.au/projects/property_guide/en/stable/index.html`,
  imageLight,
  imageDark,
  searchTags: `National Property Geoscape Property Estates Land Management Property Analysis Real Estate Spatial Data Valuation`,
  detail: () => import("../details/national-property").then((m) => m.detail),
};

export default entry;
